import { render } from "./SelectorGameCards.vue?vue&type=template&id=14c04cf7"
import script from "./SelectorGameCards.vue?vue&type=script&lang=js"
export * from "./SelectorGameCards.vue?vue&type=script&lang=js"

import "./SelectorGameCards.vue?vue&type=style&index=0&id=14c04cf7&lang=css"

import exportComponent from "C:\\src\\Inmersys\\tres-prima\\mundo-zac-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__